import ObjectTypes from 'Lib/constants/app/objectTypes';

export const OwnerShareObjectTypes = [ObjectTypes.Lease, ObjectTypes.Property, ObjectTypes.Unit, ObjectTypes.Portfolio, ObjectTypes.Contact, ObjectTypes.WorkOrder];

export const TenantShareObjectTypes = [ObjectTypes.Contact, ObjectTypes.WorkOrder];

export const VendorShareObjectTypes = [ObjectTypes.Contact, ObjectTypes.WorkOrder];

export const allowOwnerShare = objectTypeID => {
	return OwnerShareObjectTypes.includes(objectTypeID);
};

export const allowTenantShare = objectTypeID => {
	return TenantShareObjectTypes.includes(objectTypeID);
};

export const allowVendorShare = objectTypeID => {
	return VendorShareObjectTypes.includes(objectTypeID);
};
